import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Wayfair = () => {
  const navigate = useNavigate();
  const sections = [
    {
      jobTitle: 'Engineering Manager',
      team: 'Wayfair Watch',
      period: 'August 2021 - March 2023',
      description: [
        'Led iOS and full-stack engineers to deliver a Webby Award winning experience with 13%+ annual lift.',
        'Built a culture of data and feedback driven development using sales metrics, user experience research, and feedback from cross-functional partners in creative, marketing, business, product, and design.',
        'Researched homegrown and SaaS live-streaming solutions to evaluate customizability and time to market.',
        'Organized Wayfair-wide tech talks and educational clubs resulting in 1000s of learning hours.'
      ]
    },
    {
      jobTitle: 'Engineering Manager',
      team: 'Promotions Curation',
      period: 'January 2020 - December 2021',
      description: [
        'Used Proforma and Jira to automate bug intake process across the organization, saving 15+ minutes per ticket and thus, 100s of engineering hours per quarter.',
        'Increased sprint velocity by 15% and predictability by 60% by leveraging data in easyBI and retrospectives.'
      ]
    },
    {
      jobTitle: 'Software Engineer, Tech Lead',
      team: 'Landing Experiences',
      period: 'July 2018 - Dec 2019',
      description: [
        'Migrated frontend from monolith to webpack server-side render microservices; improved speed by 70%.',
        'Devised a solution to reduce a 3 week integration effort to 3 days for an internal A/B testing framework.',
        'Identified significant gap in a cross-functional redesign and escalated early, resulting in a new initiative.'
      ]
    }
  ];

  return (
    <Box>
      <Button onClick={() => navigate('/')} variant="outlined" sx={{ mb: 3 }}>
        Back to Home
      </Button>

      <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h3" gutterBottom>
          Wayfair
        </Typography>
      </Paper>

      {sections.map((sec, idx) => (
        <Paper key={idx} elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            {sec.jobTitle}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            {sec.team}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            {sec.period}
          </Typography>
          {sec.description.map((point, index) => (
            <Typography key={index} variant="body1" paragraph>
              • {point}
            </Typography>
          ))}
        </Paper>
      ))}
    </Box>
  );
};

export default Wayfair;
